jQuery(document).ready(function($) {
	if (typeof window.GardpSliderHelper !== 'function') {
		return;
	}

	window.GardpSliderHelper.initElements(
		$('.gardp-latest-posts--slider .gardp-latest-posts__grid'),
		function(element) {
			return {
				partialView: $(element).closest('.gardp-latest-posts--partial-view').length > 0,
			};
		}
	);
});
